import React from 'react';
import styled from 'styled-components';

import Heading from '../heading/Heading';
import Divider from '../styles/HorizontalDivider';

const Text = ({ colored, children, className, margin, left }) => {
    const OuterTextContainer = styled.div`
        background-color: ${props => colored
        ? props.theme.palette.secondary.A200
        : 'transparent'};
        margin: ${margin || '0'};
    `;

    const InnerTextContainer = styled.div`
        max-width: 66ch;
        padding: ${props => props.theme.space[5]} ${
        props => props.theme.space[8]} ${props => props.theme.space[5]} ${
        props => props.theme.space[10]};
        margin: ${left ? '0' : '0 auto'};
    `;

    return (
        <OuterTextContainer className={className}>
            <InnerTextContainer>
                {children}
            </InnerTextContainer>
        </OuterTextContainer>
    );
};

Text.Heading = Heading;
Text.Divider = Divider;

export default Text;



// WEBPACK FOOTER //
// ./src/components/common/Text.js